import { filter, take } from 'lodash'
import { observable, action, computed } from 'mobx'
import moment from 'moment'
import { post } from 'axios'
import { get } from 'react-global-configuration'

const ENV = (key) => {
  try {
    return get(key)
  } catch (e) {
    return {}
  }
}

const airFilter = async query => {
  if (!query || query.length < 2) return []
  const { data } = await post(`${ENV('apiDomain')}/airline/airportSuggest`, {query})
  return data
}


class AirportAutocomplete {
  @observable fromOptions = []
  @observable toOptions = []
  _currentValue = null

  @action airportSuggest = async (key, e) => {
    if (e.key === 'Enter') { return }
    const newValue = (e.target.value || '').trim()
    if (this._currentValue === newValue) { return }
    if (newValue.length < 2) { return }
    this._currentValue = newValue
    this[key] = await airFilter(newValue)
  }

  @computed get fromAirport () {
    return airFilter(this.fromOptions)
  }
}

export default new AirportAutocomplete()



// WEBPACK FOOTER //
// ./src/stores/AirportAutocomplete.js